var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .facebook-icon__path {\n        fill: #fff;\n      }\n    ")),React.createElement("path",{"className":"facebook-icon__path","d":"M1024,512C1024,229.23,794.77,0,512,0S0,229.23,0,512c0,255.55,187.23,467.37,432,505.78V660H302V512H432V399.2C432,270.88,508.44,200,625.39,200c56,0,114.61,10,114.61,10V336H675.44c-63.6,0-83.44,39.47-83.44,80v96H734L711.3,660H592v357.78C836.77,979.37,1024,767.55,1024,512Z","key":1})]);
}

FacebookIcon.defaultProps = {"id":"facebook-icon","className":"facebook-icon","data-name":"facebook-icon","viewBox":"0 0 1024 1017.78"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
